var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6654 2.66667H10.332V1.33333C10.332 0.979711 10.1916 0.640573 9.94151 0.390524C9.69146 0.140476 9.35232 0 8.9987 0L4.9987 0C4.64508 0 4.30594 0.140476 4.05589 0.390524C3.80584 0.640573 3.66536 0.979711 3.66536 1.33333V2.66667H0.332031V4H1.66536V14C1.66536 14.5304 1.87608 15.0391 2.25115 15.4142C2.62622 15.7893 3.13493 16 3.66536 16H10.332C10.8625 16 11.3712 15.7893 11.7462 15.4142C12.1213 15.0391 12.332 14.5304 12.332 14V4H13.6654V2.66667ZM4.9987 1.33333H8.9987V2.66667H4.9987V1.33333ZM10.9987 14C10.9987 14.1768 10.9285 14.3464 10.8034 14.4714C10.6784 14.5964 10.5088 14.6667 10.332 14.6667H3.66536C3.48855 14.6667 3.31898 14.5964 3.19396 14.4714C3.06894 14.3464 2.9987 14.1768 2.9987 14V4H10.9987V14Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 6.66797H5V12.0013H6.33333V6.66797Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9974 6.66797H7.66406V12.0013H8.9974V6.66797Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlinedIcon);
export default __webpack_public_path__ + "static/media/deleteOutlinedIcon.98470bf7db067720f031f1559e2e3350.svg";
export { ForwardRef as ReactComponent };